import type { ReactNode } from 'react';

import { SxProps, Theme } from '@classify/react-core-components/styles';
import Box from '@classify/react-core-components/Box';

interface Props {
  sx?: SxProps<Theme>;
  children: ReactNode;
}

const LearningStatus = ({ sx = {}, children }: Props) => (
  <Box
    sx={{
      borderRadius: '50%',
      height: 24,
      width: 24,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid',
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default LearningStatus;
